import { LessonPage } from './LessonPage';
export default LessonPage;
